var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H9C10.6569 22 12 20.6569 12 19V18.1818C12 17.6295 11.5523 17.1818 11 17.1818C10.4477 17.1818 10 17.6295 10 18.1818V19C10 19.5523 9.55228 20 9 20H5C4.44772 20 4 19.5523 4 19V5C4 4.44772 4.44772 4 5 4H9C9.55229 4 10 4.44771 10 5V5.81818C10 6.37047 10.4477 6.81818 11 6.81818C11.5523 6.81818 12 6.37047 12 5.81818V5C12 3.34314 10.6569 2 9 2H5Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7875 6.67397C15.4153 6.26596 15.4443 5.63346 15.8524 5.26124C16.2604 4.88902 16.8929 4.91804 17.2651 5.32604L22.7388 11.326C23.0871 11.7078 23.0871 12.2922 22.7388 12.674L17.2651 18.674C16.8929 19.082 16.2604 19.111 15.8524 18.7388C15.4443 18.3666 15.4153 17.7341 15.7875 17.326L19.7341 13H9C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11H19.7341L15.7875 6.67397Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.786a6caef98802d94a3759d76eaa66a3.svg";
export { ForwardRef as ReactComponent };